// hy-content video facade: shows the poster + play button and loads the Vimeo player on click,
// or - with data-autoload - as soon as it approaches the viewport (for videos that autoplayed originally).
if (!customElements.get('hy-vimeo')) {
  customElements.define('hy-vimeo', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', () => this.play(true), { once: true });
      if (this.hasAttribute('data-autoload') && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { io.disconnect(); this.play(); }
        }, { rootMargin: '200px' });
        io.observe(this);
      }
    }
    play(userStarted) {
      if (this.started) return;
      this.started = true;
      let src = this.dataset.src;
      // A tap on the play button means "play now": force autoplay so it doesn't need a second tap in Vimeo's player.
      if (userStarted) src = /[?&]autoplay=/.test(src) ? src.replace(/([?&])autoplay=[^&]*/, '$1autoplay=1') : src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
      const frame = document.createElement('iframe');
      frame.src = src;
      frame.title = this.dataset.title || 'Video';
      frame.allow = 'autoplay; fullscreen; picture-in-picture';
      frame.allowFullscreen = true;
      // Keep the poster visible until the player has loaded (no black flash).
      frame.addEventListener('load', () => this.classList.add('is-playing'), { once: true });
      this.classList.add('is-loading');
      this.append(frame);
    }
  });
}
